"use client";

import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3, 4].map(i => <li key={i} data-index={i} className="h-4 w-24 bg-muted/30 animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-secondary-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const studioLinks = [{
  label: "Beta Access",
  to: "#"
}, {
  label: "Our Vision",
  to: "/AboutPage"
}, {
  label: "Technology",
  to: "#"
}, {
  label: "Partners",
  to: "#"
}, {
  label: "Careers",
  to: "#"
}];
const resourceLinks = [{
  label: "Documentation",
  to: "#"
}, {
  label: "Tutorials",
  to: "#"
}, {
  label: "Community",
  to: "#"
}, {
  label: "Support",
  to: "#"
}, {
  label: "Press Kit",
  to: "#"
}];
const legalLinks = [{
  label: "Contact",
  to: "#"
}, {
  label: "Privacy",
  to: "#"
}, {
  label: "Terms",
  to: "#"
}, {
  label: "Security",
  to: "#"
}, {
  label: "FAQ",
  to: "#"
}];
export default function StudioFooter() {
  return <section data-section-id="231" id="studio-footer" className="bg-background text-foreground relative overflow-hidden pt-30 pb-12 px-6 md:px-12">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 left-0 right-0 w-full overflow-hidden select-none">
        <div className="font-serif text-primary/5 leading-none whitespace-nowrap tracking-tighter text-center" style={{
        fontSize: "clamp(8rem, 22vw, 18rem)"
      }}>
          RUCHNII
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {}
          <div className="space-y-5">
            <Link to="/" className="inline-block">
              <span className="font-serif text-3xl tracking-tight text-foreground">
                RUCHNII
              </span>
            </Link>
            <p className="font-default text-sm leading-relaxed text-secondary-foreground/90 max-w-xs">
              Democratizing cinematic storytelling through advanced animation tools since 2025.
            </p>
          </div>

          {}
          <div>
            
            <ul className="space-y-3">
              {studioLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-secondary-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            
            <ul className="space-y-3">
              {resourceLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-secondary-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
            <ul className="space-y-3 mt-3">
              {legalLinks.map((item, i) => <li key={item.label} data-index={i}>
                  <Link to={item.to} className="text-secondary-foreground/80 hover:text-primary text-sm font-default tracking-wide transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <Separator className="my-12 bg-primary/30" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <p className="font-default text-[10px] uppercase tracking-[0.2em] text-secondary-foreground/70 order-2 md:order-1">
            &copy; 2025 RUCHNII STUDIOS &middot; Built for creators
          </p>

          {}
          <div className="flex items-center gap-6 order-1 md:order-2">
            <Link to="#" newTab aria-label="Instagram" className="text-primary hover:text-foreground transition-colors duration-300">
              
            </Link>
            <Link to="#" newTab aria-label="Twitter" className="text-primary hover:text-foreground transition-colors duration-300">
              
            </Link>
            <Link to="#" newTab aria-label="YouTube" className="text-primary hover:text-foreground transition-colors duration-300">
              
            </Link>
          </div>

          {}
          <div className="order-3 flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-secondary-foreground/70 font-default">
            <span>Global</span>
            <span className="text-primary/50">/</span>
            <span>EN</span>
          </div>
        </div>
      </div>
    </section>;
}